import { createTheme } from '@mui/material/styles';

const darkTheme = createTheme({
  palette: {
    mode:"dark",
  },
});

export default darkTheme;